import { matchPath } from "react-router-dom";

import { SidebarItemsType } from "@/types/sidebar";
import SidebarNavListItem from "./SidebarNavListItem";
import SidebarNavList from "./SidebarNavList";

type ReduceChildRoutesProps = {
  depth: number;
  page: SidebarItemsType;
  items: JSX.Element[];
  currentRoute: string;
  collapsed?: boolean;
};

const reduceChildRoutes = (props: ReduceChildRoutesProps) => {
  const { items, page, depth, currentRoute, collapsed = false } = props;

  const open =
    page.children && page.href
      ? !!matchPath({ path: page.href, end: false }, currentRoute)
      : false;

  items.push(
    <SidebarNavListItem
      depth={depth}
      href={page.href}
      icon={page.icon}
      key={page.title}
      badge={page.badge}
      title={page.title}
      collapsed={collapsed}
      open={open}
    >
      {page.children && (
        <SidebarNavList
          depth={depth + 1}
          pages={page.children}
          collapsed={collapsed}
        />
      )}
    </SidebarNavListItem>
  );

  return items;
};

export default reduceChildRoutes;
